module.exports = __webpack_public_path__ + "resources/img/img_coolfilter1.29753c9a81577734db4c43f865f1663e.png";